var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhantom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 34,
    viewBox: "0 0 22 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.025 12.1161L19.1 8.67857V15.5536L13.025 12.1161ZM19.1 26.8482L11 31.4315L2.9 26.8482V18.8274L11 23.4107L19.1 18.8274V26.8482ZM2.9 8.67857L8.975 12.1161L2.9 15.5536V8.67857ZM12.0125 13.753L18.0875 17.1905L12.0125 20.628V13.753ZM9.9875 20.628L3.9125 17.1905L9.9875 13.753V20.628ZM18.0875 7.04167L11 10.9702L3.9125 7.04167L11 2.9494L18.0875 7.04167ZM0.875 6.3869V27.8304L11 33.3958L21.125 27.8304V6.3869L11 0.821428L0.875 6.3869Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhantom);
export default __webpack_public_path__ + "static/media/phantom.af51cbe785ef42ec6d525476b0b05ee2.svg";
export { ForwardRef as ReactComponent };